import { Injectable } from '@angular/core';
import {ServiceLibrary, ServiceReturn} from '@common_libraries/helpers/ServiceLibrary';
import { Observable } from 'rxjs';
import { Dictionary } from '@common_libraries/helpers/Dictionary';

@Injectable({providedIn: 'root'})
export class AccountSettingsService {

  public constructor(private servLib: ServiceLibrary ) { }

  // security audit 1.12.18 brc (PortfolioLayerAccountTags not used)
  GetPortfolioLayerAccountTags(name: string, rowSize: number, pageIndex: number, sortColumn: string, sortDirection: string): Observable<ServiceReturn> {

    const parameters = new Dictionary([]);

    parameters.add('name', name);
    parameters.add('rowSize', rowSize);
    parameters.add('pageIndex', pageIndex);
    parameters.add('sortColumn', sortColumn);
    parameters.add('sortDirection', sortDirection);

    return this.servLib.HttpPost('/v1/api/Company/AccountSettings/PortfolioLayerAccountTagsPaged', ServiceLibrary.ContentType.JSON, parameters);
  }

  // security audit 1.12.18 brc (PortfolioLayerAccountTags not used)
  InsertPortfolioLayerAccountTag(tagName: string): Observable<ServiceReturn> {
    const parameters = new Dictionary([]);
    parameters.add('tag', tagName);

    return this.servLib.HttpPost('/v1/api/Company/AccountSettings/PortfolioLayerAccountTags/Insert', ServiceLibrary.ContentType.JSON, parameters);
  }

  // security audit 1.12.18 brc (additional validation added) (PortfolioLayerAccountTags not used)
  UpdatePortfolioLayerAccountTag(id: number, tagName: string, active: boolean): Observable<ServiceReturn> {
    const parameters = new Dictionary([]);

    parameters.add('tag', tagName);
    parameters.add('active', active);

    return this.servLib.HttpPost('/v1/api/Company/AccountSettings/PortfolioLayerAccountTags/' + id + '/Update', ServiceLibrary.ContentType.JSON, parameters, id);
  }

  // security audit 1.12.18 brc (additional validation added) (PortfolioLayerAccountTags not used)
  DeletePortfolioLayerAccountTag(id: number): Observable<ServiceReturn> {
    const parameters = new Dictionary([]);

    return this.servLib.HttpDelete('/v1/api/Company/AccountSettings/PortfolioLayerAccountTags/' + id, ServiceLibrary.ContentType.JSON, parameters, id);
  }

  //  security audit 1.12.18 brc (only used by PortfolioLayerAccountTags which is not used, AND only one field on the model is looked at)
  GetCompany(): Observable<ServiceReturn> {
    // don't need any params
    const parameters = new Dictionary([]);

    return this.servLib.HttpGet('/v1/api/Company/AccountSettings/GetCompany', ServiceLibrary.ContentType.JSON, parameters);
  }

  //  security audit 1.12.18 brc (only used by PortfolioLayerAccountTags which is not used)
  UpdateCompany(PreventCustomPortfolioLayerTags: boolean): Observable<ServiceReturn> {
    const parameters = new Dictionary([]);

    parameters.add('PreventCustomPortfolioLayerTags', PreventCustomPortfolioLayerTags);

    return this.servLib.HttpPost('/v1/api/Company/AccountSettings/UpdateCompany', ServiceLibrary.ContentType.JSON, parameters);
  }

  //  security audit 1.12.18 brc
  GetPortfolioLayerTemplates(): Observable<ServiceReturn> {
    const parameters = new Dictionary([]);
    return this.servLib.HttpGet('/v1/api/Company/AccountSettings/PortfolioLayerFields', ServiceLibrary.ContentType.JSON, parameters);
  }

  //  security audit 1.12.18 brc
  GetPortfolioFieldList(): Observable<ServiceReturn> {
    const parameters = new Dictionary([]);
    return this.servLib.HttpGet('/v1/api/Company/AccountSettings/PortfolioLayerFieldList', ServiceLibrary.ContentType.JSON, parameters);
  }

  //  security audit 1.12.18 brc
  GetFieldListForTemplate(templateID: number): Observable<ServiceReturn> {
    const parameters = new Dictionary([]);
    return this.servLib.HttpGet('/v1/api/Company/LayerFieldsForTemplate/' + templateID, ServiceLibrary.ContentType.JSON, parameters, templateID);
  }

  //  security audit 1.12.18 brc
  UpdateLayerFieldsTemplate(templateID: number, templateName: string, defaultViewLayerSelection: boolean, defaultAddLayerSelection: boolean, fields: any[]): Observable<ServiceReturn> {
    const parameters = new Dictionary([]);
    const smallFields: any[] = fields.map((f) => {
      return {
        fieldID: f.viewColumnID,
        ordinal: f.ordinal
      };
    });
    parameters.add('templateName', templateName);
    parameters.add('defaultViewLayerSelection', defaultViewLayerSelection);
    parameters.add('defaultAddLayerSelection', defaultAddLayerSelection);
    parameters.add('fields', smallFields);

    return this.servLib.HttpPost('/v1/api/Company/layertemplates/' + templateID + '/update', ServiceLibrary.ContentType.JSON, parameters, templateID);
  }

  //  security audit 1.12.18 brc
  DeleteLayerFieldsTemplate(templateID: number): Observable<ServiceReturn> {
    const parameters = new Dictionary([]);

    return this.servLib.HttpGet('/v1/api/Company/layertemplates/' + templateID + '/delete', ServiceLibrary.ContentType.JSON, parameters, templateID);
  }

  //  security audit 1.12.18 brc
  GetClients(name: string, rowSize: number, pageIndex: number, sortColumn: string, sortDirection: string): Observable<ServiceReturn> {
    const parameters = new Dictionary([]);

    parameters.add('name', name);
    parameters.add('rowSize', rowSize);
    parameters.add('pageIndex', pageIndex);
    parameters.add('sortColumn', sortColumn);
    parameters.add('sortDirection', sortDirection);

    return this.servLib.HttpPost('/v1/api/Company/AccountSettings/ClientsPaged', ServiceLibrary.ContentType.JSON, parameters);
  }

  //  security audit 1.12.18 brc
  InsertClient(clientName: string, active: boolean): Observable<ServiceReturn> {
    const parameters = new Dictionary([]);

    parameters.add('ClientName', clientName);
    parameters.add('Active', active);

    return this.servLib.HttpPost('/v1/api/Company/AccountSettings/Clients/Insert', ServiceLibrary.ContentType.JSON, parameters);
  }

  //  security audit 1.12.18 brc
  UpdateClient(clientID: number, clientName: string, active: boolean): Observable<ServiceReturn> {
    const parameters = new Dictionary([]);

    parameters.add('ClientName', clientName);
    parameters.add('Active', active);

    return this.servLib.HttpPost('/v1/api/Company/AccountSettings/Clients/' + clientID + '/Update', ServiceLibrary.ContentType.JSON, parameters, clientID);
  }

  //  security audit 1.12.18 brc
  GetCategories(name: string, rowSize: number, pageIndex: number, sortColumn: string, sortDirection: string): Observable<ServiceReturn> {
    const parameters = new Dictionary([]);

    parameters.add('name', name);
    parameters.add('rowSize', rowSize);
    parameters.add('pageIndex', pageIndex);
    parameters.add('sortColumn', sortColumn);
    parameters.add('sortDirection', sortDirection);

    return this.servLib.HttpPost('/v1/api/Company/AccountSettings/AnalysisCategoriesPaged', ServiceLibrary.ContentType.JSON, parameters);
  }

  //  security audit 1.12.18 brc
  InsertCategory(categoryName: string): Observable<ServiceReturn> {
    const parameters = new Dictionary([]);
    parameters.add('Name', categoryName);

    return this.servLib.HttpPost('/v1/api/Company/AccountSettings/AnalysisCategories/Insert', ServiceLibrary.ContentType.JSON, parameters);
  }

  //  security audit 1.12.18 brc
  UpdateCategory(categoryID: number, categoryName: string, active: boolean): Observable<ServiceReturn> {
    const parameters = new Dictionary([]);


    parameters.add('FieldName', categoryName);
    parameters.add('Active', active);

    return this.servLib.HttpPost('/v1/api/Company/AccountSettings/AnalysisCategories/' + categoryID + '/Update', ServiceLibrary.ContentType.JSON, parameters, categoryID);
  }

  //  security audit 1.12.18 brc
  GetClasses(name: string, rowSize: number, pageIndex: number, sortColumn: string, sortDirection: string): Observable<ServiceReturn> {
    const parameters = new Dictionary([]);
    parameters.add('name', name);
    parameters.add('rowSize', rowSize);
    parameters.add('pageIndex', pageIndex);
    parameters.add('sortColumn', sortColumn);
    parameters.add('sortDirection', sortDirection);

    return this.servLib.HttpPost('/v1/api/Company/AccountSettings/AnalysisClassesPaged', ServiceLibrary.ContentType.JSON, parameters);
  }

  //  security audit 1.12.18 brc
  InsertClass(className: string): Observable<ServiceReturn> {
    const parameters = new Dictionary([]);


    parameters.add('Name', className);

    return this.servLib.HttpPost('/v1/api/Company/AccountSettings/AnalysisClasses/Insert', ServiceLibrary.ContentType.JSON, parameters);
  }

  //  security audit 1.12.18 brc
  UpdateClass(classID: number, className: string, active: boolean): Observable<ServiceReturn> {
    const parameters = new Dictionary([]);


    parameters.add('FieldName', className);
    parameters.add('Active', active);

    return this.servLib.HttpPost('/v1/api/Company/AccountSettings/AnalysisClasses/' + classID + '/Update', ServiceLibrary.ContentType.JSON, parameters, classID);
  }

  //  security audit 1.12.18 brc
  GetStatuses(name: string, rowSize: number, pageIndex: number, sortColumn: string, sortDirection: string): Observable<ServiceReturn> {
    const parameters = new Dictionary([]);


    parameters.add('name', name);
    parameters.add('rowSize', rowSize);
    parameters.add('pageIndex', pageIndex);
    parameters.add('sortColumn', sortColumn);
    parameters.add('sortDirection', sortDirection);

    return this.servLib.HttpPost('/v1/api/Company/AccountSettings/AnalysisStatusesPaged', ServiceLibrary.ContentType.JSON, parameters);
  }

  //  security audit 1.12.18 brc
  InsertStatus(statusName: string): Observable<ServiceReturn> {
    const parameters = new Dictionary([]);


    parameters.add('Name', statusName);

    return this.servLib.HttpPost('/v1/api/Company/AccountSettings/AnalysisStatuses/Insert', ServiceLibrary.ContentType.JSON, parameters);
  }

  //  security audit 1.12.18 brc
  UpdateStatus(statusID: number, statusName: string, active: boolean): Observable<ServiceReturn> {
    const parameters = new Dictionary([]);


    parameters.add('FieldName', statusName);
    parameters.add('Active', active);

    return this.servLib.HttpPost('/v1/api/Company/AccountSettings/AnalysisStatuses/' + statusID + '/Update', ServiceLibrary.ContentType.JSON, parameters, statusID);
  }

  //  security audit 1.12.18 brc
  GetExposureRegions(name: string, rowSize: number, pageIndex: number, sortColumn: string, sortDirection: string): Observable<ServiceReturn> {
    const parameters = new Dictionary([]);


    parameters.add('name', name);
    parameters.add('rowSize', rowSize);
    parameters.add('pageIndex', pageIndex);
    parameters.add('sortColumn', sortColumn);
    parameters.add('sortDirection', sortDirection);

    return this.servLib.HttpPost('/v1/api/Company/AccountSettings/ExposureRegionsPaged', ServiceLibrary.ContentType.JSON, parameters);
  }

  //  security audit 1.12.18 brc
  InsertExposureRegion(statusName: string): Observable<ServiceReturn> {
    const parameters = new Dictionary([]);


    parameters.add('Name', statusName);

    return this.servLib.HttpPost('/v1/api/Company/AccountSettings/ExposureRegions/Insert', ServiceLibrary.ContentType.JSON, parameters);
  }

  //  security audit 1.12.18 brc
  UpdateExposureRegion(exposureRegionID: number, exposureRegionName: string, active: boolean): Observable<ServiceReturn> {
    const parameters = new Dictionary([]);


    parameters.add('FieldName', exposureRegionName);
    parameters.add('Active', active);

    return this.servLib.HttpPost('/v1/api/Company/AccountSettings/ExposureRegions/' + exposureRegionID + '/Update', ServiceLibrary.ContentType.JSON, parameters, exposureRegionID);
  }

  //  security audit 1.12.18 brc
  GetLayerGroupingTypesAll(): Observable<ServiceReturn> {
    const parameters = new Dictionary([]);

    return this.servLib.HttpGet('/v1/api/Company/AccountSettings/AnalysisLayerGroupingTypes', ServiceLibrary.ContentType.JSON, parameters);
  }

  //  security audit 1.12.18 brc
  GetLayerGroupingTypes(name: string, rowSize: number, pageIndex: number, sortColumn: string, sortDirection: string): Observable<ServiceReturn> {
    const parameters = new Dictionary([]);


    parameters.add('name', name);
    parameters.add('rowSize', rowSize);
    parameters.add('pageIndex', pageIndex);
    parameters.add('sortColumn', sortColumn);
    parameters.add('sortDirection', sortDirection);

    return this.servLib.HttpPost('/v1/api/Company/AccountSettings/AnalysisLayerGroupingTypesPaged', ServiceLibrary.ContentType.JSON, parameters);
  }

  //  security audit 1.12.18 brc
  InsertLayerGroupingType(groupingTypeName: string, active: boolean): Observable<ServiceReturn> {
    const parameters = new Dictionary([]);

    parameters.add('GroupName', groupingTypeName);
    parameters.add('Active', active);

    return this.servLib.HttpPost('/v1/api/Company/AccountSettings/AnalysisLayerGroupingTypes/Insert', ServiceLibrary.ContentType.JSON, parameters);
  }

  //  security audit 1.12.18 brc
  UpdateLayerGroupingType(groupingTypeID: number, groupingTypeName: string, active: boolean): Observable<ServiceReturn> {
    const parameters = new Dictionary([]);

    parameters.add('GroupName', groupingTypeName);
    parameters.add('Active', active);

    return this.servLib.HttpPost('/v1/api/Company/AccountSettings/AnalysisLayerGroupingTypes/' + groupingTypeID + '/Update', ServiceLibrary.ContentType.JSON, parameters, groupingTypeID);
  }

  //  security audit 1.12.18 brc
  GetLossFileAdjustmentLabels(): Observable<ServiceReturn> {
    const parameters = new Dictionary([]);

    return this.servLib.HttpGet('/v1/api/Company/AccountSettings/LossFileAdjustmentLabels', ServiceLibrary.ContentType.JSON, parameters);
  }

  //  security audit 1.12.18 brc
  GetWindowingData() {
    const parameters = new Dictionary(([]));
    return this.servLib.HttpGet('/v1/api/Company/AccountSettings/Windowing/GetWindowingData', ServiceLibrary.ContentType.JSON, parameters);
  }

  //  security audit 1.12.18 brc
  SaveWindowingData(windowingData: any) {
    const parameters = new Dictionary([]);
    parameters.add('Windows', windowingData);
    return this.servLib.HttpPost('/v1/api/Company/AccountSettings/Windowing/SaveWindowingData', ServiceLibrary.ContentType.JSON, parameters);

  }

  //  security audit 1.12.18 brc
  GetModelData(includeActive: boolean, includeGlobal: boolean, modelId?: number) {
    const parameters = new Dictionary([]);
    parameters.add('IncludeInactive', includeActive);
    parameters.add('IncludeGlobal', includeGlobal);
    if (modelId != null) {
      parameters.add('ModelId', modelId);
    }
    return this.servLib.HttpPost('/v1/api/AccountServicesController/GetModelData', ServiceLibrary.ContentType.JSON, parameters);
  }

  //  security audit 1.12.18 brc
  GetActiveModelData() : Observable<Response>{
    const parameters = new Dictionary([]);
    return this.servLib.HttpGet('/v1/api/AccountServicesController/GetActiveModelData', ServiceLibrary.ContentType.JSON, parameters);
  }

  //  security audit 1.12.18 brc
  SaveModelActiveSetting(modelID: number, isActive: boolean) {
    const parameters = new Dictionary([]);
    parameters.add('ModelID', modelID);
    parameters.add('IsActive', isActive);

    return this.servLib.HttpPost('/v1/api/AccountServicesController/SaveModelActiveSetting', ServiceLibrary.ContentType.JSON, parameters, modelID);

  }

  //  security audit 1.12.18 brc
  InsertModelConfiguration(shortDescription: string, description: string, annualCorrelation: boolean, allowRegionMapping: boolean) {
    const parameters = new Dictionary([]);
    parameters.add('ShortDescription', shortDescription);
    parameters.add('Description', description);
    parameters.add('AnnualCorrelation', annualCorrelation);
    parameters.add('AllowRegionMapping', allowRegionMapping);
    return this.servLib.HttpPost('/v1/api/AccountServicesController/InsertModelConfiguration', ServiceLibrary.ContentType.JSON, parameters);
  }

  //  security audit 1.12.18 brc
  GetAddendaForCatalog(id: number) {
    const parameters = new Dictionary([]);

    return this.servLib.HttpGet('/v1/api/CatalogInternal/' + id + '/Addendums', ServiceLibrary.ContentType.JSON, parameters);
  }

  //  security audit 1.12.18 brc
  PublishCatalogAddendum(id: number) {
    const parameters = new Dictionary([]);

    return this.servLib.HttpGet('/v1/api/Catalog/' + id + '/PublishCatalogAddendum', ServiceLibrary.ContentType.JSON, parameters);
  }

  ProcessUploadedRDSEventFile(fileID: string) {
    const parameters = new Dictionary([]);
    parameters.add('uniqueIdentifier', fileID);
    return this.servLib.HttpPost('/v1/api/Company/AccountSettings/ProcessUploadedRDSEventFiles', ServiceLibrary.ContentType.JSON, parameters);
  }

  GetParticipationEventOccurrenceList() {
    const parameters = new Dictionary([]);
    return this.servLib.HttpGet('/v1/api/Company/AccountSettings/ParticipationEventOccurrenceList', ServiceLibrary.ContentType.JSON, parameters);
  }

  UpdateParticipationEventOccurrence(portfolioParticipationYLTFilterID: number, Name: string, Description: string, Active: boolean) {
    const parameters = new Dictionary([]);
    parameters.add('PortfolioParticipationYLTFilterID', portfolioParticipationYLTFilterID);
    parameters.add('Name', Name);
    parameters.add('Description', Description);
    parameters.add('Active', Active);
    return this.servLib.HttpPost('/v1/api/Company/AccountSettings/UpdateParticipationEventOccurrence', ServiceLibrary.ContentType.JSON, parameters);
  }

  ImportEventOccurrenceData(Name: string, Description: string, EventOccurrenceData: any) {
    const parameters = new Dictionary([]);
    parameters.add('Name', Name);
    parameters.add('Description', Description);
    parameters.add('EventOccurrenceData', EventOccurrenceData);
    return this.servLib.HttpPost('/v1/api/Company/AccountSettings/ImportEventOccurrenceData', ServiceLibrary.ContentType.JSON, parameters);
  }

  GenerateOccurrenceDelayedDownload(Name: string, portfolioParticipationYLTFilterID: any) {
    const parameters = new Dictionary([]);
    parameters.add('Name', Name);
    return this.servLib.HttpPost('/v1/api/Company/AccountSettings/GenerateOccurrenceDelayedDownload/' + portfolioParticipationYLTFilterID, ServiceLibrary.ContentType.JSON, parameters);
  }

  RegionMappingPBToSQL(regionDefinitionAttrID: number) {
    const parameters = new Dictionary([]);
    parameters.add('RegionDefinitionAttrID', regionDefinitionAttrID);
    return this.servLib.HttpPost('/v1/api/Company/AccountSettings/RegionMapping/ImportRegionDefinitionPBToSQL', ServiceLibrary.ContentType.JSON, parameters);
  }

  GetAllAccountSettings() {
    const parameters = new Dictionary([]);
    return this.servLib.HttpGet('/v1/api/Company/AccountSettings/GetAllSettings', ServiceLibrary.ContentType.JSON, parameters);
  }

  GetAccountSettingByID(accountSettingID: number) {
    const parameters = new Dictionary([]);
    return this.servLib.HttpGet('/v1/api/Company/AccountSettings/GetSetting/' + accountSettingID, ServiceLibrary.ContentType.JSON, parameters);
  }

  UpdateAccountSetting(accountSettingID: number, settingValue: boolean) {
    const parameters = new Dictionary([]);
    parameters.add('AccountSettingID', accountSettingID);
    parameters.add('SettingValue', settingValue);
    return this.servLib.HttpPost('/v1/api/Company/AccountSettings/UpdateSetting', ServiceLibrary.ContentType.JSON, parameters);
  }

}
